// const siteEvents = [
//     {
//         event_type: "order",
//         event_name: "T Formula Lessons",
//         event_action: "joined",
//         event_time: "2024-08-25 19:46:52.319138 +0100 WAT",
//         event_actor: "Margaret AAAA",
//         event_country: "US"
//     },
//     {
//         event_type: "signup",
//         event_name: "StepUp",
//         event_action: "joined",
//         event_time: "2024-08-25 19:48:52.319138 +0100 WAT",
//         event_actor: "Blessing Adams",
//         event_country: "KE"
//     },
//     {
//         event_type: "order",
//         event_name: "E-Guide",
//         event_action: "purchased",
//         event_time: "2024-08-25 19:48:52.319138 +0100 WAT",
//         event_actor: "Goodnews Rock",
//         event_country: "ZA"
//     }
// ];

// Events are sent in from backend by html templates

let currentEventIndex = 0;
let socialProofDiv;
let closeButton;


function parseCustomDateString(dateString) {
    // Check if the string contains a space, which indicates the first format
    if (dateString.includes(' ')) {
        // Remove the timezone abbreviation (e.g., "WAT")
        const dateWithoutZone = dateString.replace(/ [A-Z]{3}$/, '');

        // Extract the date part, time part, and the timezone offset
        const [datePart, timePart, offsetPart] = dateWithoutZone.split(' ');

        // Trim the milliseconds to 3 digits if necessary
        const trimmedTimePart = timePart.replace(/(\.\d{3})\d+/, '$1');

        // Reformat the date string to ISO 8601 format
        const isoDateString = `${datePart}T${trimmedTimePart}${offsetPart}`;

        // Create and return a new Date object
        return new Date(isoDateString);
    } else {
        // If it's already in ISO format, just return a new Date object
        return new Date(dateString);
    }
}

// Examples:
// console.log(parseCustomDateString("2024-08-26 03:19:51.592958 +0100 WAT"));
// console.log(parseCustomDateString("2024-06-15T05:05:07.032946+01:00"));

function parseCustomDateStringUTC(dateString) {
    // Remove the timezone abbreviation (e.g., "WAT")
    const dateWithoutZone = dateString.replace(/ [A-Z]{3}$/, '');

    // Extract the date part, time part, and the timezone offset
    const [datePart, timePart, offsetPart] = dateWithoutZone.split(' ');

    // Trim the milliseconds to 3 digits if necessary
    const trimmedTimePart = timePart.replace(/(\.\d{3})\d+/, '$1');

    // Manually calculate the offset in minutes
    const offsetSign = offsetPart[0] === '+' ? 1 : -1;
    const offsetHours = parseInt(offsetPart.slice(1, 3), 10);
    const offsetMinutes = parseInt(offsetPart.slice(3), 10);
    const totalOffsetMinutes = offsetSign * (offsetHours * 60 + offsetMinutes);

    // Create a Date object from the UTC time
    const utcDate = new Date(`${datePart}T${trimmedTimePart}Z`);

    // Adjust the date by the offset
    utcDate.setMinutes(utcDate.getMinutes() + totalOffsetMinutes);

    return utcDate;
}

// Example usage:
// const dateString = "2024-08-25 19:48:52.319138 +0100 WAT";
// const parsedDate = parseCustomDateString(dateString);
// console.log(parsedDate); // Outputs the correct date object


function timeDifferenceHours(eventTime) {
    const now = new Date();
    const eventDate = parseCustomDateString(eventTime);
    // const diffInSeconds = Math.floor((now - eventDate) / 1000);
    // Don't allow for negative time
    const diffInSeconds = Math.floor((now - eventDate) / 1000);
    let plural = 's'
    if (diffInSeconds < 60) { 
        plural = (diffInSeconds < 2)? '': plural  
        if (diffInSeconds < 2) {
            return `Just now`;
        }      
        return `${diffInSeconds} second${plural} ago`;
    } else if (diffInSeconds < 3600) {
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        plural = (diffInMinutes < 2)? '': plural 
        return `${diffInMinutes} minute${plural} ago`;
    } else {
        const diffInHours = Math.floor(diffInSeconds / 3600);
        plural = (diffInHours < 2)? '': plural
        return `${diffInHours} hour${plural} ago`;
    }
}


function timeDifference(eventTime) {

    const now = new Date();
    const eventDate = parseCustomDateString(eventTime);
    // const diffInSeconds = Math.floor((now - eventDate) / 1000);
    // Don't allow for negative time.
    const diffInSeconds = Math.floor((now - eventDate) / 1000);

    let plural = 's'
    if (diffInSeconds < 60) {
        plural = (diffInSeconds < 2)? '': plural
        if (diffInSeconds < 2) {
            return `Just now`;
        }       
        return `${diffInSeconds} second${plural} ago`;
    } else if (diffInSeconds < 3600) {
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        plural = (diffInMinutes < 2)? '': plural 
        return `${diffInMinutes} minute${plural} ago`;
    } else if (diffInSeconds < 86400) { // Less than a day
        const diffInHours = Math.floor(diffInSeconds / 3600);
        plural = (diffInHours < 2)? '': plural
        return `${diffInHours} hour${plural} ago`;
    } else {
        const diffInDays = Math.floor(diffInSeconds / 86400);
        plural = (diffInDays < 2)? '': plural
        return `${diffInDays} day${plural} ago`;
    }
}

function generateTimeDifferenceDisplay(eventTime) {
    // TODO: Use Regex to test for real event times.
    // But for now, check for recently and return it
    if (eventTime == "-" || eventTime == "_" || eventTime == "Recently" || eventTime == "recently" || eventTime == "" || eventTime == " ") {
        return eventTime
    }

    return timeDifference(eventTime)
}



function formatNameForDisplay(fullName) {
    // Trim the fullName before processing
    fullName = fullName.trim();

    // If the fullName is empty, replace it with "DD"
    if (!fullName) {
        fullName = "Em";
    }

    // Replace consecutive spaces with a single space
    fullName = fullName.replace(/\s+/g, ' ');

    fullName = capitalizeFirstLetter(fullName)
    // console.log(fullName)

    // Check if the name is entirely numeric
    if (/^\d+$/.test(fullName)) {
        if (fullName.length > 6) {
            return `${fullName.slice(-6)}...`;
        }
        return fullName;
    }

    const parts = fullName.split(' ');

    let firstName = parts[0] || "";

    // Mask firstname from index 3 (up to but not including 3, only 0,1,2)
    if (firstName.length > 3) {
        firstName = `${firstName.slice(0, 3)}***`
    } else if (firstName.length == 3) {
        // For three letter names like Joy
        firstName = `${firstName.slice(0, 2)}***`
    }

    if (parts.length === 1) {
        // If there is no second part, use the first part and repeat the initial
        // const firstName = parts[0];
        const result = `${firstName} ${firstName[0].toUpperCase()}.`;

        if (result.length > 15) {
            return `${firstName.slice(0, 14)} ${firstName[0].toUpperCase()}.`;
        }
        return result;
    }

    // If there are more than two names, use only the first and second parts for initials
    // const firstName = parts[0] || "";
    const secondPartInitial = (parts[1] || "")[0]?.toUpperCase() || firstName[0].toUpperCase();

    const fullResult = `${firstName} ${secondPartInitial}.`;

    if (fullResult.length <= 15) {
        return fullResult;
    } else {
        const truncatedFirstName = firstName.slice(0, 14 - secondPartInitial.length - 1);
        return `${truncatedFirstName} ${secondPartInitial}.`;
    }
}

// // Examples:
// console.log(formatName("")); // "DD D."
// console.log(formatName("Jonathan")); // "Jonathan J."
// console.log(formatName("Supercalifragilisticexpialidocious Miller")); // "Supercalifrag M."
// console.log(formatName("   Jonathan   J   ")); // "Jonathan J."
// console.log(formatName("12345678901234567890")); // "345678..."


// Example usage:
/*
console.log(formatName("1234567890"));           // "567890..."
console.log(formatName("123456"));               // "123456"
console.log(formatName("John Doe"));            // "John D."
console.log(formatName("Alexandria Johnson"));  // "Alexandria J."
console.log(formatName("Jonathan"));            // "Jonathan J"
console.log(formatName("Christopher Stevenson"));// "Christopher S."
console.log(formatName("Supercalifragilisticexpialidocious Miller")); // "Supercalifrag M."
console.log(formatName("Supercalifragilisticexpialidocious")); // "Supercalifra S."
*/



function updateSocialProofDivEdge(event) {
    let actorInitials = event.event_actor.includes(' ')
        ? event.event_actor.split(' ').map(name => name[0]).join('')
        : event.event_actor[0] + event.event_actor[0];
    
    let actorName = formatNameForDisplay(event.event_actor)
    // let actorName = event.event_actor.length > 15 ? event.event_actor.slice(0, 15) + '...' : event.event_actor;
    // let eventName = event.event_name.indexOf(' ') === -1 ? event.event_name[0] + event.event_name : event.event_name;
    let eventName = event.event_name.trim();
    let eventInfo = `Recently ${event.event_action} ${eventName}`;
    // let eventInfo = `Just ${event.event_action} ${eventName}`;
    let eventDescription = eventInfo.length > 24 ? eventInfo.slice(0, 24) + '...' : eventInfo.trim();

    // console.log(eventInfo)
    // console.log("===========", eventDescription)
    
    let eventTime = generateTimeDifferenceDisplay(event.event_time);
    // let eventTime = timeDifference(event.event_time);

    let eventCountry = event.event_country
    eventCountry = eventCountry.toUpperCase()

    document.getElementById('actor-initials').innerText = actorInitials.toUpperCase();
    document.getElementById('actor-name').innerText = `${actorName} (${eventCountry})`;
    document.getElementById('event-description').innerText = eventDescription
    // `Just ${event.event_action} ${eventName}`;
    document.getElementById('event-time').innerText = eventTime;
}


function updateSocialProofDiv(event) {
    // Trim the event_actor and replace consecutive spaces with a single space
    let actor = event.event_actor.trim().replace(/\s+/g, ' ');

    // If event_actor is empty, assign "Em"
    if (!actor) {
        actor = "Em";
    }

    // Generate initials based on the first two parts of the actor's name
    const actorParts = actor.split(' ');
    let actorInitials;
    if (actorParts.length > 1) {
        actorInitials = actorParts[0][0] + actorParts[1][0];
    } else {
        actorInitials = actorParts[0][0] + actorParts[0][0];
    }

    // Format the actor's name for display
    let actorName = formatNameForDisplay(actor);

    // Clean up event name and description
    let eventName = event.event_name.trim();
    // let eventName = event.event_name.trim();
    let eventInfo = `Recently ${event.event_action} ${eventName}`;
    // let eventInfo = `Recently ${event.event_action}`;
    let eventDescription = eventInfo.length > 68 ? eventInfo.slice(0, 65) + '...' : eventInfo.trim(); //Recently subscribed for | Recently joined

    // Just ordered How to Conceive Multiple Boys (42)
    // Recently purchased Pinkbluers Gender Selection Metho... 52(55)
    // Recently purchased Pinkbluers Gender Selection Method eboo... 58(61)
    // Recently purchased Pinkbluers Gender Selection Method ebook conceive... 68(71)
    // Goes to second line at 46 (Maybe make it 60 chars)
    // Recently purchased Pinkbluers Gender Selection (46) 

    // Calculate event time difference
    let eventTime = generateTimeDifferenceDisplay(event.event_time);
    // let eventTime = timeDifference(event.event_time);

    // Convert event country to uppercase
    let eventCountry = event.event_country.toUpperCase();

    // Change the initials-bg color
    switchColorClasses(event.actor_desired_gender)

    // Update the social proof div elements
    document.getElementById('actor-initials').innerText = actorInitials.toUpperCase();
    document.getElementById('actor-name').innerText = `${actorName} (${eventCountry})`;
    document.getElementById('event-description').innerText = eventDescription;
    // document.getElementById('event-name').innerText = eventName;
    document.getElementById('event-time').innerText = eventTime;
}


function switchColorClasses(desired_gender) {
    let initialsBg = document.getElementById('actor-initials-bg')
    desired_gender = desired_gender.toLowerCase()

    // To test for male first, you also have to ensure it isn't female
    if (desired_gender.includes("female") || desired_gender.includes("girl") ) {
        initialsBg.classList.remove('bg-blue-500');
        initialsBg.classList.add('bg-pink-400');
    }else {
        // Male and Mixed
        initialsBg.classList.remove('bg-pink-400');
        initialsBg.classList.add('bg-blue-500');
    }
}

// https://stackoverflow.com/questions/1026069/how-do-i-make-the-first-letter-of-a-string-uppercase-in-javascript
function capitalizeFirstLetter(s)
{
    // console.log("full name: ", s)
    s = s.toLowerCase(s.trim())
    if (s == "") {
        return s 
    }
    return s[0].toUpperCase() + s.slice(1);
}

function showNextEvent() {
    // If no site Events return
    if (siteEvents.length < 1) {
        return false
    }
    updateSocialProofDiv(siteEvents[currentEventIndex]);
    socialProofDiv.classList.add('slide-down');
    socialProofDiv.classList.remove('hidden');
    

    setTimeout(() => {
        socialProofDiv.classList.remove('slide-up');
        socialProofDiv.classList.add('slide-down');

        setTimeout(() => {
            socialProofDiv.classList.add('hidden');
            currentEventIndex = (currentEventIndex + 1) % siteEvents.length;
            setTimeout(showNextEvent, 5000);
        }, 6000);
    }, 6000);
}

function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
        return;
    }
    document.addEventListener('DOMContentLoaded', fn);
}


function initSocialProof (){

    socialProofDiv = document.getElementById('social-proof');
    closeButton = document.getElementById('close-btn');

    closeButton.addEventListener('click', () => {
        socialProofDiv.classList.add('slide-down');
    
        setTimeout(() => {
            socialProofDiv.classList.add('hidden');
            setTimeout(showNextEvent, 5000);
        }, 500);
    });
    
    socialProofDiv.addEventListener('mouseover', () => {
        closeButton.classList.remove('hidden');
    });
    
    socialProofDiv.addEventListener('mouseout', () => {
        closeButton.classList.add('hidden');
    });


    // First one should display early
    setTimeout(showNextEvent, 2000);
};

ready(function(){
    console.log("ready")
    initSocialProof()
})
